import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const WarningIcon = (props) => (
    <SvgIcon viewBox="0 0 16 16" {...props}>
        <rect width="16" height="16" fill="#FFF3D0" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.51766 2.76592C8.94153 1.69391 7.48734 1.69391 6.91108 2.76592L2.2 11.5299C1.62816 12.5936 2.35074 13.9173 3.50332 13.9173H12.9255C14.078 13.9173 14.8006 12.5936 14.2289 11.5299L9.51766 2.76592Z"
            fill="#CA9400"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.15298 6.73639C9.15298 6.18558 8.73297 5.73907 8.2148 5.73907C7.69665 5.73907 7.27661 6.18558 7.27661 6.73639V8.33209C7.27661 8.88292 7.69665 9.3294 8.2148 9.3294C8.73297 9.3294 9.15298 8.88292 9.15298 8.33209V6.73639ZM8.2148 12.5208C8.73297 12.5208 9.15298 12.0742 9.15298 11.5235C9.15298 10.9727 8.73297 10.5262 8.2148 10.5262C7.69665 10.5262 7.27661 10.9727 7.27661 11.5235C7.27661 12.0742 7.69665 12.5208 8.2148 12.5208Z"
            fill="#FFF3D0"
        />
    </SvgIcon>
);

export default WarningIcon;
